module.exports = "https://cdn.hellotech.com/client-assets/HomeTheater_9e5096bedf450363dd5e5b59519e2d76.png";